import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

import { IChangeLaundryCancelCommissionsBody } from "types/laundry";

const useChangeLaundryCancelCommissionsMutation = () => {
  return useMutation(async (data: IChangeLaundryCancelCommissionsBody) => {
    try {
      const res = await laundriesService.changeLaundryCancelCommissions(data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useChangeLaundryCancelCommissionsMutation